import $ from 'jquery';

// rspec でモーダルが完全に表示されたタイミングを待つためのdata属性を追加する。
// 本番では不要なものだが、害はないので残しておく。
$(document).on('shown.bs.modal', (e) => {
  e.target.setAttribute('data-test-modal-status', 'shown');
});
$(document).on('hide.bs.modal', (e) => {
  e.target.removeAttribute('data-test-modal-status');
});
